import React, { useContext } from "react";
import { Button, Dropdown, Tooltip, Typography } from "antd";
import { DownOutlined, RobotOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useFleetAssistant } from "../../context/FleetAssistantContext";
import "./ContextToolbar.css";
import LanguageButton from "../language/LanguageButton";
import { AuthContext } from "../../context/AuthContext";
import { isManagerRole } from "../../auth/fleetRoles";

const CategoryDropdown = ({ category }) => {
  const options = category?.options || [];
  const triggerButton = (
    <Button
      className="context-toolbar-trigger"
      shape="round"
      icon={category?.triggerIcon}
      disabled={category?.disabled}
      aria-label={category?.triggerLabel}
      title={category?.triggerLabel}
    >
      <DownOutlined />
    </Button>
  );

  const dropdownContent = (
    <div className="context-toolbar-dropdown">
      {options.length === 0 ? (
        <Typography.Text type="secondary">
          {category?.emptyText || "No options"}
        </Typography.Text>
      ) : (
        <div className="context-toolbar-options-list">
          {options.map((option) => {
            return (
              <div key={option.key} className="context-toolbar-option-row">
                <Tooltip title={option.tooltip}>
                  <Button
                    type={option.active ? "primary" : "default"}
                    shape="circle"
                    icon={option.icon}
                    disabled={option.disabled}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      if (option.disabled) return;
                      option.onToggle?.();
                    }}
                    aria-label={option.tooltip}
                  />
                </Tooltip>
                {typeof option.count === "number" ? (
                  <Typography.Text className="context-toolbar-option-count">
                    {option.count}
                  </Typography.Text>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  return (
    <Dropdown trigger={["click"]} dropdownRender={() => dropdownContent}>
      {triggerButton}
    </Dropdown>
  );
};

export default function ContextToolbar({ searchSlot, categories = [], actionsSlot, className = "" }) {
  const { isAssistantOpen, toggleAssistant } = useFleetAssistant();
  const { t } = useTranslation();
  const { getFleetID, fleetRole } = useContext(AuthContext);

  return (
    <div className={`context-toolbar ${className}`.trim()}>
      <div className="context-toolbar-left">
        <Tooltip
          title={
            isAssistantOpen
              ? t("fleetAssistant.close", { defaultValue: "Close Fleet Assistant" })
              : t("fleetAssistant.open", { defaultValue: "Open Fleet Assistant" })
          }
        >
          <Button
            className="context-toolbar-assistant-btn"
            shape="round"
            type={isAssistantOpen ? "primary" : "default"}
            icon={<RobotOutlined />}
            onClick={toggleAssistant}
          />
        </Tooltip>
        {searchSlot}
      </div>
      <div className="context-toolbar-center">
        {categories.map((category) => (
          <CategoryDropdown key={category.key} category={category} />
        ))}
      </div>
      {actionsSlot ? <div className="context-toolbar-right">{actionsSlot}</div> : null}
      <LanguageButton compact fleetId={isManagerRole(fleetRole)?getFleetID():undefined} />
    </div>
  );
}
